/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from './api';

/**
 * Sprint 2 — Doctor Productivity clients.
 *
 * - AI Prescription OCR (Claude 3.5 Vision)
 * - IoT / Health Data (Apple Health / Google Fit stub + manual measurements)
 */

// ---- OCR ----
export async function scanPrescription({ image_base64, mime_type, patient_context } = {}) {
  const res = await api.post('/ocr/prescription', { image_base64, mime_type, patient_context });
  return res.data; // { extraction_id, result, meta }
}

// Read a File as base64 with data-URL header stripped.
export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    if (!file) { reject(new Error('No file')); return; }
    const r = new FileReader();
    r.onerror = () => reject(r.error || new Error('read error'));
    r.onload = () => {
      const s = String(r.result || '');
      const idx = s.indexOf(',');
      resolve({ base64: idx >= 0 ? s.slice(idx + 1) : s, dataUrl: s, mime: file.type });
    };
    r.readAsDataURL(file);
  });
}

// ---- IoT / Health Data ----
export async function listIoTProviders() {
  const res = await api.get('/iot/providers');
  return res.data; // { providers: [...] }
}

export async function connectIoTProvider(providerId, consent = true) {
  const res = await api.post(`/iot/connect/${providerId}`, { consent });
  return res.data;
}

export async function disconnectIoTProvider(providerId) {
  const res = await api.post(`/iot/disconnect/${providerId}`);
  return res.data;
}

export async function pushHealthData(payload) {
  // payload: { metric, value, unit?, provider?, measured_at? }
  const res = await api.post('/iot/health-data', payload);
  return res.data;
}

export async function listHealthData({ metric, since_hours = 24 * 30, limit = 200 } = {}) {
  const params = { since_hours, limit };
  if (metric) params.metric = metric;
  const res = await api.get('/iot/health-data', { params });
  return res.data;
}

export async function getHealthSummary() {
  const res = await api.get('/iot/summary');
  return res.data;
}
